import { FC } from 'react';
import * as React from 'react';

import { clsx } from 'clsx';
import styled from 'styled-components';

const OptionContent = styled.div<{ isSelected: boolean }>`
  border: 2px solid
    ${({ isSelected }) =>
      isSelected ? 'var(--color-primary-light-400)' : '#292c47'};
  border-radius: 20px;
  height: 80px;
  &:hover {
    border: 2px solid var(--color-primary-light-400);
  }
  &:hover svg {
    color: var(--color-primary-light-400);
  }
  @media (min-width: 768px) {
    height: 120px;
  }
  @media (min-width: 1024px) {
    height: 190px;
  }
`;

type OptionProps = {
  onClick(): void;
  label: string;
  isLastItem?: boolean;
  isSelected: boolean;
  businessLogo: (value: boolean) => JSX.Element;
};

const Option: FC<React.PropsWithChildren<OptionProps>> = ({
  onClick,
  label,
  isLastItem,
  isSelected,
  businessLogo,
}) => {
  return (
    <OptionContent
      isSelected={isSelected}
      className={clsx(
        'font-poppins cursor-pointer w-full flex flex-row items-center md:flex-col transition-all justify-between px-16 sm:px-24 md:px-16 md:pt-16 text-white',
        {
          'mb-16 sm:mb-24 md:mr-32': !isLastItem,
        },
      )}
      onClick={onClick}
    >
      <div className="w-full justify-end hidden md:flex">
        <div
          className="w-20 h-20 rounded-full flex items-center justify-center"
          css={`
            border: 2px solid
              ${isSelected ? 'var(--color-primary-light-400)' : '#b7bad5'};
          `}
        >
          {isSelected && (
            <div
              className="rounded-full"
              css={`
                width: 10px;
                height: 10px;
                background: var(--color-primary-light-400);
              `}
            />
          )}
        </div>
      </div>
      <p className="text-center text-14 leading-22 md:mb-16 font-semibold">
        {label}
      </p>
      <div className="flex self-end md:mx-auto">{businessLogo(isSelected)}</div>
    </OptionContent>
  );
};

export default Option;
